function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import { AUTO, BEST, ECO, GOOD, LOW } from "constants/cloudinary-asset-qualities";
export default {
    type: FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({}, SharedAdvancedFieldsConfig), {
        assetQuality: {
            type: FIELD_TYPES.COMBO,
            label: "Asset Quality",
            options: [
                {
                    value: AUTO,
                    text: "Auto"
                },
                {
                    value: BEST,
                    text: "Best"
                },
                {
                    value: GOOD,
                    text: "Good"
                },
                {
                    value: ECO,
                    text: "Eco"
                },
                {
                    value: LOW,
                    text: "Low"
                }
            ]
        },
        width: {
            type: FIELD_TYPES.TEXT,
            label: "Asset width in desktop (% only)"
        },
        mobileWidth: {
            type: FIELD_TYPES.TEXT,
            label: "Asset width in mobile (% only)"
        },
        fullWidth: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Disable maximum width limitation (1440px)"
        }
    })
};
